export const combineUsersName = (user: { firstName?: string; lastName?: string }) => {
  return [user?.firstName, user?.lastName]
    .filter((item) => !!item)
    .map((item) => item.trim())
    .join(' ');
};
